import React from 'react'; //eslint-disable-line no-unused-vars
import RedirectWithParams from '../components/redirect/RedirectWithParams';
import {getPath} from '@epic-core/common';
import pluginRegistry from '../plugin/PluginProvider';

export const redirectLocale = (destination, route) => {
    const path = getPath();
    let destPath = null;
    if (typeof destination === 'function') {
        destPath = destination(route.match.params);
    } else {
        destPath = destination;
    }
    const redirectUrl = `${path}${route.match.params.locale}${destPath}`;
    return <RedirectWithParams to={redirectUrl} />;
};

export function getRouteDefinitions() {
    return [...pluginRegistry.getRouteDefinitions()];
}
